import jwtDecode from 'jwt-decode';

/**
 * Decode JWT token safely without verification
 * Note: This only checks expiration for UX purposes
 * Never use the payload for security decisions - trust backend validation only
 *
 * The backend MUST verify the JWT signature before accepting it
 */
export const verifyToken = (token) => {
  if (!token) {
    return false;
  }

  try {
    const decoded = jwtDecode(token);

    // Check if token has expiration
    if (!decoded.exp) {
      console.warn('Token missing expiration claim');
      return false;
    }

    // Check if token is expired (with 30 second buffer)
    const currentTime = Date.now() / 1000;
    const expirationBuffer = 30; // seconds
    const isExpired = decoded.exp - expirationBuffer <= currentTime;

    if (isExpired) {
      console.warn('Token has expired');
      return false;
    }

    return true;
  } catch (error) {
    console.error('Token verification error:', error);
    return false;
  }
};

/**
 * Get token expiration time for refresh scheduling
 * Returns expiration timestamp or null if invalid
 */
export const getTokenExpiration = (token) => {
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    return decoded.exp ? decoded.exp * 1000 : null; // Convert to milliseconds
  } catch (error) {
    console.error('Error getting token expiration:', error);
    return null;
  }
};
